import { render, staticRenderFns } from "./UserRoot.vue?vue&type=template&id=0233341e&scoped=true"
import script from "./UserRoot.vue?vue&type=script&lang=ts"
export * from "./UserRoot.vue?vue&type=script&lang=ts"
import style0 from "./UserRoot.vue?vue&type=style&index=0&id=0233341e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0233341e",
  null
  
)

export default component.exports